window.ImageBackground = function() {
    var el = this;
    var isMoving = false;
    var elsList = {};

    el.beginMove = function() {
        isMoving = true;
        el._parent.isTransforming = true;

        elsList = {
            element: document.getElementById(
                'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId),
            lastX: 0,
            lastY: 0,
        };

        elsList.pos = {
            x: 0,
            y: 0,
            width: el.workData.width,
            height: el.workData.height,
        };

        var workarea = el._parent.workData.workareas[el.selectWorkareaId];
        var image = workarea.backgrounds[el.selectId];

        elsList.pos.x = image.x;
        elsList.pos.y = image.y;
        elsList.pos.width = image.width;
        elsList.pos.height = image.height;

        if (el.workData.is_single_content === '1') {
            elsList.pos.x = elsList.pos.x + workarea.left;
            elsList.pos.y = elsList.pos.y + workarea.top;
        }
    };

    el.move = function(event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX -
                    elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY -
                    elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            var workarea;
            var imagePosElement = el.transform.getArea(elsList.element);
            if (el.workData.is_single_content === '1') {
                if (
                    0 >= imagePosElement.x1 + movementX
                    && el.workData.width <= imagePosElement.x2 + movementX
                    && 0 >= imagePosElement.y1 + movementY
                    && el.workData.height <= imagePosElement.y2 + movementY
                ) {
                    var i;
                    for (i in el._parent.workData.workareas) {
                        updateData(i);
                    }

                    elsList.pos.x += movementX;
                    elsList.pos.y += movementY;
                }
            } else {
                workarea = el._parent.workData.workareas[el.selectWorkareaId];

                if (
                    0 >= imagePosElement.x1 + movementX
                    && workarea.width <= imagePosElement.x2 + movementX
                    && 0 >= imagePosElement.y1 + movementY
                    && workarea.height <= imagePosElement.y2 + movementY
                ) {
                    updateData(el.selectWorkareaId);

                    elsList.pos.x += movementX;
                    elsList.pos.y += movementY;
                }
            }

            function updateData(workareaId)
            {
                var image = el._parent.workData.workareas[workareaId].backgrounds[el.selectId];
                var element = document.getElementById(
                    'backgrounds-item-' + workareaId + '-' + el.selectId);
                var pos = el.transform.setOffsetPosition(element, movementX, movementY);

                var rotate = el.transform.getRotate(element);
                image.rotate_angle = rotate.angle;
                image.rotate_x = rotate.x;
                image.rotate_y = rotate.y;

                image.x = pos.x;
                image.y = pos.y;
            }

            var element = document.getElementById(
                'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId);
            el.selection.update(element);
        }
    };

    el.endMove = function() {
        if (isMoving) {
            isMoving = false;
            el.history.add();
        }
    };

    el.rotate = function(angle) {
        var element, riData;

        if (el.workData.is_single_content === '1') {
            var i;
            for (i in el._parent.workData.workareas) {
                updateData(i);
            }
        } else {
            updateData(el.selectWorkareaId);
        }

        function updateData(workareaId)
        {
            riData = el._parent.workData.workareas[workareaId].backgrounds[el.selectId];
            element = document.getElementById('backgrounds-item-' + workareaId + '-' + el.selectId);

            if (!riData.hasOwnProperty('rotate_angle')) {
                riData.rotate_angle = 0;
            }

            riData.rotate_angle += angle;

            el.upImages.reinitImagePosition(workareaId, el.selectType, el.selectId);
            element.setAttribute('x', riData.x);
            element.setAttribute('y', riData.y);
            element.setAttribute('width', riData.width);
            element.setAttribute('height', riData.height);
            el.transform.setRotate(element, riData.rotate_angle);
        }

        var element = document.getElementById(
            'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId);
        el.selection.update(element);

        el.history.add();
    };

    el.resize = function(diff) {
        var data = {};

        var globalPos, pos = {}, workareaPos;

        var workarea = el._parent.workData.workareas[el.selectWorkareaId];
        var image = workarea.backgrounds[el.selectId];
        var ratio = image.width / image.height;

        if (el.workData.is_single_content === '1') {
            globalPos = {
                x: 0,
                y: 0,
                width: el.workData.width,
                height: el.workData.height,
            };

            pos.x = image.x + workarea.left;
            pos.y = image.y + workarea.top;
            pos.width = image.width;
            pos.height = image.height;

            data.x = parseInt(pos.x) - diff;
            data.y = parseInt(pos.y) - parseInt(diff / ratio, 10);
            data.width = parseInt(pos.width) + 2 * diff;
            data.height = parseInt(pos.height) + parseInt(2 * diff / ratio, 10);

            var i, workarea;
            for (i in el._parent.workData.workareas) {
                workarea = el._parent.workData.workareas[i];

                workareaPos = $.extend(true, {}, data);
                workareaPos.x -= workarea.left;
                workareaPos.y -= workarea.top;

                updateData(i, globalPos, data, workareaPos);
            }
        } else {
            globalPos = {
                x: 0,
                y: 0,
                width: workarea.width,
                height: workarea.height,
            };

            pos.x = image.x;
            pos.y = image.y;
            pos.width = image.width;
            pos.height = image.height;

            data.x = parseInt(pos.x) - diff;
            data.y = parseInt(pos.y) - parseInt(diff / ratio, 10);
            data.width = parseInt(pos.width) + 2 * diff;
            data.height = parseInt(pos.height) + parseInt(2 * diff / ratio, 10);

            workareaPos = $.extend(true, {}, data);

            updateData(el.selectWorkareaId, globalPos, data, workareaPos);
        }

        function updateData(workareaId, globalPos, data, workareaPos)
        {
            var element = document.getElementById(
                'backgrounds-item-' + workareaId + '-' + el.selectId);
            var workarea = el._parent.workData.workareas[workareaId];
            var image = workarea.backgrounds[el.selectId];

            var valvePos = {
                x: data.x,
                y: data.y,
                width: data.width,
                height: data.height,
            };

            if (
                (globalPos.x >= valvePos.x &&
                    parseInt(globalPos.x) + parseInt(globalPos.width) <= parseInt(valvePos.x) +
                    parseInt(valvePos.width) &&
                    globalPos.y >= parseInt(valvePos.y) &&
                    parseInt(globalPos.y) + parseInt(globalPos.height) <= parseInt(valvePos.y) +
                    parseInt(valvePos.height))
                || image.hasOwnProperty('mask')
            ) {

                image.x = workareaPos.x;
                image.y = workareaPos.y;
                image.width = workareaPos.width;
                image.height = workareaPos.height;

                element.setAttribute('width', workareaPos.width);
                element.setAttribute('height', workareaPos.height);
                element.setAttribute('x', workareaPos.x);
                element.setAttribute('y', workareaPos.y);
            }
        }

        var element = document.getElementById(
            'backgrounds-item-' + el.selectWorkareaId + '-' + el.selectId);
        el.selection.update(element);

        el.history.add();
    };

    el.remove = function() {
        if (el.workData.is_single_content === '1') {
            var i;
            for (i in el._parent.workData.workareas) {
                updateData(i);
            }
        } else {
            updateData(el.selectWorkareaId);
        }

        function updateData(workareaId)
        {
            if (el._parent.hasOwnProperty('upImages')) {
                el.upImages.unsetUsedImage(
                    el.workData.workareas[workareaId].backgrounds[el.selectId].name);
            }

            delete el._parent.workData.workareas[workareaId].backgrounds[el.selectId];
        }

        el.selection.hide();
        el.history.add();
    };
};